/**
 * Notifications API client
 */
import { apiClient } from '../api-client';

// ==================== Types ====================

export interface Notification {
  id: number;
  notification_type: string;
  priority: string;
  title: string;
  message: string;
  data?: any;
  action_url?: string;
  is_read: boolean;
  read_at?: string;
  created_at: string;
}

export interface NotificationsResponse {
  notifications: Notification[];
  unread_count: number;
}

// ==================== API Functions ====================

/**
 * Get all notifications for current user
 */
export async function getNotifications(unreadOnly: boolean = false): Promise<NotificationsResponse> {
  const response = await apiClient.get('/notifications', { unread_only: unreadOnly });
  return response;
}

/**
 * Get unread notification count
 */
export async function getUnreadCount(): Promise<{ unread_count: number }> {
  const response = await apiClient.get('/notifications/unread-count');
  return response;
}

/**
 * Mark notification as read
 */
export async function markNotificationRead(notificationId: number): Promise<void> {
  await apiClient.put(`/notifications/${notificationId}/read`);
}

/**
 * Mark all notifications as read
 */
export async function markAllNotificationsRead(): Promise<void> {
  await apiClient.put('/notifications/read-all');
}

/**
 * Delete a notification
 */
export async function deleteNotification(notificationId: number): Promise<void> {
  await apiClient.delete(`/notifications/${notificationId}`);
}